
/**
 * @description
 * Redirect to right route if needed
 * 
 * @param {Object} to 
 * @param {Object} from 
 * @param {Object} next 
 * @return {void}
 */
export default function guard(to, from, next) {
	if(process.env.VUE_APP_BY_PASS_LOGIN === 'false')
		callSecureGuard(to, from, next)
	else // Ignore login data
		callInsecureGuard(to, from, next)
	goToNext_WithParamsIfNeeded(to, from, next)
}

/**
 * @description
 * Management login and application routes with user data login
 * 
 * @param {Object} to 
 * @param {Object} from 
 * @param {Object} next 
 * @return void
 */
function callSecureGuard(to, from, next) {
	let isAuthenticated = !! ( localStorage.getItem('user-token') || '' )
	let regexResetPassUrl = /\/password\/reset(\/?|\/\w)/g; // regex => /password/reset/:token

	if(to.path === "/login" || to.path === '/password/email' || regexResetPassUrl.test(to.path)) 
	{
		// send user to root path if already is authenticated
		if(isAuthenticated) {
			goToRedirect_WithParamsIfNeeded('/', from, next)
			return
		}
	}
	else { // user isn't visiting auth views and user want to go to dashboard 
		if(! isAuthenticated) {
			next('/login')
			return
		}
	} // end if-else
}

/**
 * @description
 * Avoid go to logins routes (Login, Email, Reset). 
 * Used when Vue Environment Var "VUE_APP_BY_PASS_LOGIN" is "false"]
 * 
 * @param {Object} to 
 * @param {Object} from 
 * @param {Object} next 
 * @return void
 */
function callInsecureGuard(to, from, next) {
	let regexResetPassUrl = /\/password\/reset(\/?|\/\w)/g; // regex => /password/reset/:token
	if(to.path === "/login" || to.path === '/password/email' || regexResetPassUrl.test(to.path)) {
		goToRedirect_WithParamsIfNeeded('/', from, next)
		return
	}
}

/**
 * @description
 * Check if Route has Query Params (Cash Desk Token)
 * 
 * @param {Object} route 
 * @return {bool}
 */
function hasQueryParams(route) {
	return !!Object.keys(route.query).length
  }

/**
 * @description
 * Go to next route and add params if exist in from route
 * 
 * @param {Object} to 
 * @param {Object} from 
 * @param {Object} next 
 * @return {void}
 */
function goToNext_WithParamsIfNeeded(to, from, next) {
	if(!hasQueryParams(to) && hasQueryParams(from))
		next({name: to.name, query: from.query});
	else 
		next()
}

/**
 * @description
 * Go to next redirect route and add params if exist in from route
 * 
 * @param {string} redirect 
 * @param {Object} from 
 * @param {Object} next 
 * @return {void}
 */
function goToRedirect_WithParamsIfNeeded(redirect, from, next) {
	if(hasQueryParams(from))
		next({name: redirect, query: from.query});
	else 
		next()
}